import type { MenuProps as MuiMenuProps } from '@mui/material/Menu';

export type PaginationSelectMenuPlacement = Pick<MuiMenuProps, 'anchorOrigin' | 'transformOrigin'>;

export const paginationSelectMenuPlacement: PaginationSelectMenuPlacement = {
  anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
  transformOrigin: { vertical: 'top', horizontal: 'center' },
};

export const paginationSelectMenuPlacementAbove: PaginationSelectMenuPlacement = {
  anchorOrigin: { vertical: 'top', horizontal: 'right' },
  transformOrigin: { vertical: 'bottom', horizontal: 'center' },
};

const MENU_VIEWPORT_MARGIN_PX = 16;

export const PAGINATION_SELECT_MENU_CARET_OFFSET_PX = -20;

export const resolvePaginationSelectMenuPlacement = (
  anchorElement: HTMLElement,
  estimatedMenuHeightPx: number,
): PaginationSelectMenuPlacement => {
  const anchorRect = anchorElement.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const availableBelow = viewportHeight - anchorRect.bottom - MENU_VIEWPORT_MARGIN_PX;
  const availableAbove = anchorRect.top - MENU_VIEWPORT_MARGIN_PX;

  if (availableBelow < estimatedMenuHeightPx && availableAbove >= estimatedMenuHeightPx) {
    return paginationSelectMenuPlacementAbove;
  }

  return paginationSelectMenuPlacement;
};
